export enum FeeProcessType {
    DirectDebit = 1,//BACS
    CreditCard = 2,
    SEPA = 5,
    CPA = 6,
    PNZ = 7
}